'use client';

import type { CSSProperties, InputHTMLAttributes, SelectHTMLAttributes, TextareaHTMLAttributes } from 'react';
import { listingFormStyles as s } from './listingFormStyles';

export function FieldLabel({
  htmlFor,
  children,
  required,
  optional,
}: {
  htmlFor: string;
  children: React.ReactNode;
  required?: boolean;
  optional?: boolean;
}) {
  return (
    <label htmlFor={htmlFor} style={s.label}>
      <span>{children}</span>
      {required ? <span style={s.required}>Required</span> : null}
      {optional ? <span style={s.optional}>Optional</span> : null}
    </label>
  );
}

export function TextInput({
  error,
  style,
  ...rest
}: InputHTMLAttributes<HTMLInputElement> & { error?: boolean; style?: CSSProperties }) {
  return <input {...rest} style={{ ...(error ? s.inputError : s.input), ...(style || {}) }} />;
}

export function TextTextarea({
  error,
  style,
  ...rest
}: TextareaHTMLAttributes<HTMLTextAreaElement> & { error?: boolean; style?: CSSProperties }) {
  return (
    <textarea
      {...rest}
      style={{
        ...s.textarea,
        ...(error ? { borderColor: '#b91c1c' } : null),
        ...(style || {}),
      }}
    />
  );
}

export function TextSelect({
  error,
  style,
  children,
  ...rest
}: SelectHTMLAttributes<HTMLSelectElement> & { error?: boolean; style?: CSSProperties }) {
  return (
    <select {...rest} style={{ ...(error ? s.inputError : s.select), ...(style || {}) }}>
      {children}
    </select>
  );
}

export function FieldError({ id, message }: { id?: string; message?: string }) {
  if (!message) return null;
  return (
    <p id={id} style={s.fieldError} role="alert">
      {message}
    </p>
  );
}

export function FieldGrid({ cols = 2, children }: { cols?: 2 | 3; children: React.ReactNode }) {
  return <div style={cols === 3 ? s.grid3 : s.grid2}>{children}</div>;
}
